import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IApiResult } from "../shared/models/api-result";
import { IRosterType } from "../shared/models/roster/roster-type";
import { IRosterCodeSetting } from "../shared/models/roster-code-setting";
import { ApiUrlProvider } from "./api-url.provider";

@Injectable({
  providedIn: "root"
})
export class RosterCodeSettingService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IRosterCodeSetting[]>>{
    return this.http.get<IApiResult<IRosterCodeSetting[]>>(`${this.apiUrlProvider.url}/RosterCodeSetting`);
  }

  add(entity: IRosterCodeSetting): Observable<IApiResult<IRosterCodeSetting>>{
    return this.http.post<IApiResult<IRosterCodeSetting>>(`${this.apiUrlProvider.url}/RosterCodeSetting`, entity);
  }

  update(entity: IRosterCodeSetting[]): Observable<IApiResult<IRosterCodeSetting[]>>{
    return this.http.post<IApiResult<IRosterCodeSetting[]>>(`${this.apiUrlProvider.url}/RosterCodeSetting`, entity);
  }
}
